{
	"title": "PIRATE 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Full Sails",
		"achievements": "Treasures",
		"reset": "Abandon Ship"
	},
	"messages": {
		"prophecy": "Arr, the ancient clickin' prophecy starts to unfold, ye scurvy dog!",
		"cosmic": "Shiver me timbers, the cosmic clickin' crew be proud of yer progress!",
		"astral": "The clickin' echoes through the seven seas of the astral plane...",
		"speaking": "Blimey! Did ye hear that? The clicks be speakin' to me...",
		"ancient": "Yer clickin' resonates with the power of Davy Jones himself!",
		"sages": "The Click Sages whisper tales of yer potential, ye swab...",
		"demons": "BEHOLD! The Click Demons rise from the briny deep!",
		"veil": "Yer clicks pierce the veil like a cutlass through sail!",
		"spirits": "The Click Spirits dance a jolly sailor's jig to yer rhythm...",
		"council": "The Grand Click Council of Pirates has noticed yer dedication",
		"primordial": "Yer clickin' awakens forces from the bottom of the sea!",
		"void": "The clickin' void stares back at ye like a hungry kraken...",
		"runes": "Ancient pirate click runes glow with yer power!",
		"beast": "THREE THREE THREE - THE NUMBER OF THE CLICK BEAST, YE SCALLYWAG",
		"prophets": "The Click Prophets sing shanties of yer coming!",
		"dimensions": "Yer clicks echo through the seven dimensional seas...",
		"portal": "Yer clicks have opened a portal to Tortuga!",
		"sacrifice": "The ancient Click Gods demand MORE PLUNDER",
		"jackpot": "TREASURE FOUND! The Click Casino welcomes its newest buccaneer!",
		"unmatched": "你的点击力量无人能及! (Yer clickin' power be unmatched, ye sea dog!)",
		"reality": "Reality itself bends to yer clickin' like a ship in a storm!",
		"elite": "YE BE THE ELITE CLICK CAPTAIN NOW",
		"power": "Yer clickin' power level be over 1500 doubloons!",
		"devils": "The Click Devils bow before yer mighty cutlass",
		"lucky": "Lucky clicks flow through yer veins like rum",
		"dynasty": "The Click Dynasty recognizes ye as the Pirate King",
		"twoThousand": "Two thousand clicks of pure pirate power!",
		"quartet": "The prophecy of the Click Shanty Quartet be fulfilled",
		"transcend": "Yer clickin' transcends mortal understanding, by thunder!",
		"constellation": "The Click Stars align to guide yer ship",
		"destiny": "THREE THOUSAND CLICKS OF PIRATE DESTINY",
		"triforce": "The Triple Click Trident awakens!",
		"fortune": "Fortune favors the bold clicker of the seas",
		"newDimensions": "Yer clickin' power reaches new oceans",
		"quartet2": "The Quadruple Click Shanty crew harmonizes",
		"threshold": "Standing at the helm of click divinity",
		"ultimate": "FIVE THOUSAND CLICKS OF ULTIMATE PIRATE POWER!",
		"force": "The Five Fingered Click Force be yours to command",
		"underworld": "The Click Underworld crowns ye their Pirate King",
		"maxJackpot": "MAXIMUM TREASURE CLICKING ACHIEVED",
		"infinite": "无限点击力量! (INFINITE PIRATE CLICKING POWER!)",
		"godhood": "YE HAVE ASCENDED TO CLICK PIRATE GODHOOD",
		"burrow": "Ye've dug deeper than any rabbit what ever sailed the seven seas...",
		"warren": "The Grand Warren recognizes ye as a proper captain...",
		"thump": "The deck shakes with every stomp of yer peg leg!",
		"darkWarren": "The Dark Warren opens its skull-and-crossbones gates fer ye...",
		"ears": "Yer ears grow longer... ye can hear every whisper on the wind...",
		"carrotThrone": "The Carrot Throne rises from the briny deep before ye...",
		"onesAlignment": "All ones align - the Warren's Signal Flags wave in harmony!",
		"moonSummon": "The Moon Rabbit hears yer shanty across the void...",
		"edgeOfForever": "Ye stand at the edge of forever... ears twitchin' like a compass needle...",
		"beyondTheVeil": "Beyond the fog, all warrens become one mighty fleet...",
		"sequence": "1-2-3-4-5... The Sacred Hop Shanty be complete!",
		"hyperElite": "HYPER ELITE PIRATE BUNNY STATUS UNLOCKED 🐇🐇🐇",
		"eventHorizon": "Past the edge of the map where sea monsters dwell...",
		"matrixAwakens": "The Warren Matrix glitches... ye see the carrots behind the sea chart",
		"luckyForever": "Every paw, every hop, every twitch of yer whiskers... blessed by the sea forever",
		"twentyK": "TWENTY THOUSAND LEAGUES. Ye be no longer a bunny. Ye be THE bunny captain.",
		"singularity": "The Pirate Bunny Singularity. All rabbits sail under yer flag. Ye be every rabbit.",
		"tripleAscension": "The Triple Ascension of the Cosmic Hare! All hands on deck!",
		"ultimateAnswer": "42,000 doubloons - The Ultimate Answer was carrots all along, ye scallywag",
		"eternity": "♾️ THE ETERNAL WARREN HAS NO PORT OF CALL. NEITHER DO YE. ♾️"
	},
	"achievements": {
		"title": "Treasures",
		"noAchievements": "No booty plundered yet. Keep clickin', ye scurvy dog!",
		"unlocked": "Treasure Found: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Landlubber Bunny",
		"carrotSnatcher": "🥕 Vegetable Pillager",
		"bunnyBerserker": "😡 Mad Sea Dog's Rampage",
		"hopPunk": "🎸 Mutinous Cottontail",
		"bunnyNinja": "🥷 Silent but Deadly Buccaneer",
		"expert": "🌟 Seasoned Sailor",
		"master": "👑 Captain of the Carrots",
		"carrotpocalypse": "🥕 Scourge of the Garden Seas",
		"bunnyOverlord": "😈 Admiral of the Warren",
		"chaosHare": "🌪️ Storm Bringer of the Seven Seas",
		"carrotCultist": "⛪ High Priest of Davy Jones' Locker",
		"bunnyberryPie": "🥧 Ship's Cook of Madness",
		"rabbitHole": "🕳️ Black Hole Digger",
		"moonRabbit": "🌙 Navigator of the Starlit Seas",
		"bunnyDoom": "💀 Herald of the Rabbit's Revenge",
		"carrotNuke": "☢️ Master of the Carrot Cannon",
		"bunnyMatrix": "🤖 Ghost in the Ship's Matrix",
		"cosmicHare": "🌌 The Cosmic Sea Hare Awakens",
		"warrenSingularity": "🕳️ Warren Singularity Achieved, Captain",
		"eternalBunny": "♾️ The Eternal Buccaneer Bunny"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Extra Doubloons!",
		"clickStreak": "🔥 {{count}} Click Streak, Ye Scurvy Dog!",
		"fire": "🔥 Cannon Fire Power Ready!"
	},
	"table": {
		"achievement": "Plunder",
		"progress": "Distance Sailed"
	},
	"reset": {
		"confirm": "Arr ye sure ye want to scuttle all yer progress? There be no gettin' it back once it's gone to Davy Jones' locker!"
	}
}
